import { createClient } from '@supabase/supabase-js';

// Runtime globals (__SUPABASE_URL__, __SUPABASE_ANON_KEY__) on globalThis take precedence
// when a Cloudflare Pages Worker injects them before the app bundle for per-environment isolation.
// globalThis works in both browser and Node.js (vitest) without undefined errors.
// Falls back to compile-time VITE_* env vars for production (no injector set up yet).
const supabaseUrl = (globalThis as any).__SUPABASE_URL__ ?? import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = (globalThis as any).__SUPABASE_ANON_KEY__ ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    // OAuth returns an implicit-flow hash on Pages previews. Persist to
    // sessionStorage so the callback can navigate without losing the session,
    // while avoiding durable localStorage token storage.
    persistSession: true,
    storage: typeof window !== 'undefined' ? window.sessionStorage : undefined,
    detectSessionInUrl: true,
  },
});
